import { render, staticRenderFns } from "./TransactionTypeSelect.vue?vue&type=template&id=0b700e48&"
import script from "./TransactionTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./TransactionTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports